
import { motion } from "motion/react";
import { X } from "lucide-react";
import { useTranslations } from "@/i18n";

interface DeckOverviewProps {
  titles: string[];
  current: number;
  onSelect: (index: number) => void;
  onClose: () => void;
}

export function DeckOverview({
  titles,
  current,
  onSelect,
  onClose,
}: DeckOverviewProps) {
  const t = useTranslations("deckViewer");

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className="fixed inset-0 z-50 overflow-y-auto bg-black/85 backdrop-blur-md"
      role="dialog"
      aria-label={t("overviewTitle")}
    >
      <div className="mx-auto max-w-5xl px-6 py-12">
        <div className="flex items-center justify-between">
          <h2 className="text-[14px] font-bold uppercase tracking-widest text-white/70">
            {t("overviewTitle")}
          </h2>
          <button
            type="button"
            onClick={onClose}
            aria-label={t("close")}
            className="rounded-full p-2 text-white/70 transition-colors hover:bg-white/10 hover:text-white"
          >
            <X size={18} />
          </button>
        </div>
        <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-4">
          {titles.map((title, index) => (
            <button
              key={index}
              type="button"
              onClick={() => onSelect(index)}
              className={`rounded-lg border p-4 text-left transition-colors ${
                index === current
                  ? "border-landing-accent bg-landing-accent/15"
                  : "border-white/15 bg-white/5 hover:border-white/40 hover:bg-white/10"
              }`}
            >
              <span className="font-mono text-[11px] text-landing-accent">
                {String(index + 1).padStart(2, "0")}
              </span>
              <p className="mt-1 text-[13px] font-medium leading-snug text-white">
                {title}
              </p>
            </button>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
